import React from 'react'
import PropTypes from 'prop-types'
import ComingSoonOverlay from '../ComingSoonOverlay/ComingSoonOverlay'
import styles from './MockedPanel.module.scss'

export default function MockedPanel({ children, gap = null }) {
  return (
    <div className="position-relative">
      <div className={styles.content}>{children}</div>
      <ComingSoonOverlay gap={gap} />
    </div>
  )
}

MockedPanel.propTypes = {
  children: PropTypes.node.isRequired,
  gap: PropTypes.shape({ reason: PropTypes.string }),
}
